import { required } from "vuelidate/lib/validators";

export function clearCepTransporte(cep) {
  return String(cep || "").replace(/\D/g, "");
}

export const descricaoTransporteValida = value =>
  !!(value && String(value).trim());

export const cepTransporteZerado = value =>
  clearCepTransporte(value) === "00000000";

export const cepTransporteValido = value => {
  const cep = clearCepTransporte(value);
  return cep.length === 8 && cep !== "00000000";
};

export const diasTransporteValidos = value => {
  if (isCampoVazio(value)) {
    return false;
  }

  const num = Number(value);
  return num >= 0 && Number.isInteger(num);
};

export const validacoesFormaTransporteCliente = {
  descricaoFormaTransporte: { required, descricaoTransporteValida },
  cepInicial: { required, cepTransporteValido },
  cepFinal: { required, cepTransporteValido },
  quantDiasPreparo: { required, diasTransporteValidos },
  quantDiasEntrega: { required, diasTransporteValidos }
};

export function isCampoVazio(value) {
  return value === null || value === undefined || value === "";
}

export function validarFormaTransporteCliente(forma, index = null) {
  const errors = [];
  const prefix = index !== null ? `Forma ${index + 1}: ` : "";

  if (
    !forma.descricaoFormaTransporte ||
    !String(forma.descricaoFormaTransporte).trim()
  ) {
    errors.push(`${prefix}Informe a descrição da forma de transporte`);
  }

  if (!cepTransporteValido(forma.cepInicial)) {
    errors.push(
      `${prefix}${
        cepTransporteZerado(forma.cepInicial)
          ? "CEP inicial não pode ser zerado"
          : "CEP inicial inválido"
      }`
    );
  }
  if (!cepTransporteValido(forma.cepFinal)) {
    errors.push(
      `${prefix}${
        cepTransporteZerado(forma.cepFinal)
          ? "CEP final não pode ser zerado"
          : "CEP final inválido"
      }`
    );
  }

  if (isCampoVazio(forma.quantDiasPreparo)) {
    errors.push(`${prefix}Informe a quantidade de dias de preparo`);
  } else if (
    forma.quantDiasPreparo < 0 ||
    !Number.isInteger(Number(forma.quantDiasPreparo))
  ) {
    errors.push(
      `${prefix}A quantidade de dias de preparo deve ser um valor inteiro positivo`
    );
  }

  if (isCampoVazio(forma.quantDiasEntrega)) {
    errors.push(`${prefix}Informe a quantidade de dias de entrega`);
  } else if (
    forma.quantDiasEntrega < 0 ||
    !Number.isInteger(Number(forma.quantDiasEntrega))
  ) {
    errors.push(
      `${prefix}A quantidade de dias de entrega deve ser um valor inteiro positivo`
    );
  }

  return errors;
}

export function isFormaTransporteClienteValida(forma) {
  return validarFormaTransporteCliente(forma).length === 0;
}

const CAMPOS_FORMA_TRANSPORTE = [
  "descricaoFormaTransporte",
  "cepInicial",
  "cepFinal",
  "custoTransporte",
  "custoPercentualSeguro",
  "pesoInicial",
  "pesoFinal",
  "quantDiasPreparo",
  "quantDiasEntrega",
  "totalPedidoInicial",
  "totalPedidoFinal"
];

export function formaTransporteTemDados(forma) {
  if (!forma || typeof forma !== "object") {
    return false;
  }

  return CAMPOS_FORMA_TRANSPORTE.some(campo => !isCampoVazio(forma[campo]));
}

export function validarDetalhesTransporteCliente(formas, formaPendente = null) {
  const errors = [];

  if ((formas || []).length) {
    formas.forEach((forma, index) => {
      validarFormaTransporteCliente(forma, index).forEach(error => {
        errors.push(error);
      });
    });
    return errors;
  }

  if (formaTransporteTemDados(formaPendente)) {
    validarFormaTransporteCliente(formaPendente).forEach(error => {
      errors.push(error);
    });

    if (!errors.length) {
      errors.push(
        "Clique em Adicionar para incluir o detalhe de transporte preenchido"
      );
    } else {
      errors.push("Complete os detalhes de transporte e clique em Adicionar");
    }

    return errors;
  }

  errors.push("Adicione pelo menos um detalhe de transporte");
  return errors;
}
